export default () => {
    console.log('popinCookies');

    const popinCookiesShowDetailsBtn = document.querySelectorAll('.btn.rgpd-btn-detail');

    function toggleDetailsPanel(event) {
        if (!event.target.closest('.cat').classList.contains('open')) {
            event.target.classList.add('open');
            event.target.closest('.cat').classList.add('open');
            event.target.setAttribute('aria-expanded', true);
        } else {
            event.target.classList.remove('open');
            event.target.closest('.cat').classList.remove('open');
            event.target.setAttribute('aria-expanded', false);
        }
    }

    if (popinCookiesShowDetailsBtn) {
        popinCookiesShowDetailsBtn.forEach(btn => {
            btn.addEventListener('click', event => {
                toggleDetailsPanel(event);
            });
        });
    }
};
